<template>
  <div class="page-tab-warpper">
    <div class="banner" v-if="!!banner">
      <img :src="banner" />
    </div>
    <div class="page-width-warpper">
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <template v-for="(item, i) in breadcrumb">
            <el-breadcrumb-item
              :key="item.path + i"
              v-if="!!item.path"
              :to="{ path: item.path }"
            >
              {{ item.name }}
            </el-breadcrumb-item>
            <el-breadcrumb-item :key="i" v-else>
              {{ item.name }}
            </el-breadcrumb-item>
          </template>
        </el-breadcrumb>
      </div>
      <div class="tab-flex">
        <div class="tabs" v-if="tabList && tabList.length">
          <ul>
            <li
              v-for="(item, i) in tabList"
              :key="i"
              :class="{ active: value === item[listKey] }"
              @click="tabClick(item)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="content"><slot></slot></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    banner: {
      type: String,
      default: "",
    },
    breadcrumb: {
      type: Array,
      default: () => [],
    },
    tabList: {
      type: Array,
      default: () => [],
    },
    listKey: {
      type: String,
      default: "id",
    },
    listName: {
      type: String,
      default: "name",
    },
  },
  methods: {
    tabClick(item) {
      if (item[this.listKey] === this.value) return;
      this.$emit("input", item[this.listKey]);
      this.$emit("change", item);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss"; // global css

.page-tab-warpper {
  .banner {
    img {
      display: block;
      width: 100%;
    }
  }
  .page-width-warpper {
    padding: 25px 0 40px;
  }
  .breadcrumb {
    .el-breadcrumb {
      font-size: 16px;
    }
  }
  .tab-flex {
    display: flex;
    margin-top: 30px;
    .tabs {
      width: 245px;
      margin-right: 100px;
      ul {
        li {
          font-size: 18px;
          line-height: 64px;
          color: #000;
          @include clamp(1);
          cursor: pointer;
          padding: 0 52px;
          &.active {
            background: #efefef;
          }
        }
      }
    }
    .content {
      flex: 1;
      ::v-deep img {
        max-width: 100%;
      }
    }
  }
}
.isMobile {
  .page-width-warpper {
    padding: 15px 0;
  }
  .tab-flex {
    display: block;
    .tabs {
      width: 100%;
      margin-bottom: 12px;
      margin-right: 0;
      text-align: center;
      border-bottom: 1px solid #eee;
    }
  }
}
</style>
